module.exports = __webpack_public_path__ + "static/media/icon_other.69be0281.svg";